import { DelegateMapEntry } from 'containers/Base/ActionDelegate';
import { Module } from 'data/terra/Module';
import { ModuleSelectorState } from '../reducer';

export const ADD_MODULE = 'ADD_MODULE';

export interface AddModuleAction {
  type: typeof ADD_MODULE;
  module: Module;
}

export const addModuleDelegate: DelegateMapEntry<
  AddModuleAction,
  ModuleSelectorState
> = {
  [ADD_MODULE]: (
    state: ModuleSelectorState,
    action: AddModuleAction
  ): ModuleSelectorState => {
    return {
      ...state,
      modules: [...state.modules, action.module],
    };
  },
};
